export * from "./app.config";



// WEBPACK FOOTER //
// ./src/services/index.js